import Api from '@/services/api'

export default {
  namespaced: true,
  state: {
    topCategories: [],
    belowCategories: [],
    currentCategory: null
  },

  mutations: {
    setTopCategories (state, categories) {
      state.topCategories = categories.data.filter((category) => {
        return category.is_top_level
      })
    },

    setBelowCategories (state, categories) {
      state.belowCategories = categories.data.filter((category) => {
        return !category.is_top_level
      })
    },

    setCurrentCategory (state, category) {
      state.currentCategory = category
    }
  },

  actions: {
    async getAllCategories ({ commit }) {
      const res = await Api.get(`categories`)

      commit('setTopCategories', res.data)
      commit('setBelowCategories', res.data)
    }
  }
}
